import { colors, makeStyles } from "@material-ui/core";

import { PhoneNumberInputProps } from "./PhoneNumberInput";

const renderCountryItem = (size: string): number => {
  switch (size) {
    case "large":
      return 46;
    case "medium":
      return 40;
    case "small":
      return 30;
  }

  return 30;
};

const defaultBorder = (theme): string => {
  return theme.palette.border.input;
};

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      transition: theme.transitions.create([
        "border-color",
        "box-shadow",
        "background-color",
      ]),
      borderRadius: 2,

      "& label": {
        display: "block",
        color: (prop: PhoneNumberInputProps) =>
          !prop.error ? theme.palette.text.primary : theme.palette.error.main,
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: 13,
        padding: 0,
        marginBottom: 8,
        textAlign: "left",
        cursor: "pointer",
      },
    },

    innerRoot: {
      position: "relative",
      width: "100%",
    },

    error: {
      display: "block",
      color: theme.palette.error.main,
      fontWeight: theme.typography.fontWeightLight,
      fontSize: 13,
      marginTop: 6,
      textAlign: "left",
    },

    wrapper: {
      border: (prop: PhoneNumberInputProps) =>
        !prop.error
          ? `1px solid ${defaultBorder(theme)}`
          : `1px solid ${theme.palette.error.main}`,
      height: (prop: PhoneNumberInputProps) => renderCountryItem(prop.size),
      paddingLeft: 14,

      "& .overlay": {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "100%",
        zIndex: 1000,

        backgroundColor: "#fcfcfb",
        opacity: 0.4,
      },
    },

    wrapperInner: {
      height: "100%",
      width: "100%",
    },

    options: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,

      "& .optionWrapper": {
        width: "100%",

        paddingTop: 8,
        paddingBottom: 8,
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[2],

        transition: theme.transitions.create(["max-height", "width"]),

        "& .placeholder": {
          width: "100%",
          fontSize: 14,
          color: colors.grey[500],
          fontWeight: theme.typography.fontWeightLight,

          padding: "0 14px",
          marginBottom: "6px",

          "& .placeholderExtra": {
            display: "inline-block",
            color: colors.blue[300],
            fontWeight: theme.typography.fontWeightMedium,
            cursor: "pointer",
          },
        },

        "& .countryItems": {
          overflowX: "none",
          overflowY: "auto",
          maxHeight: "600px",
          marginTop: 8,
        },

        "& .countryItem": {
          padding: "6px 14px",
          fontSize: 14,
          fontWeight: theme.typography.fontWeightLight,
          cursor: "pointer",

          "&:hover": {
            backgroundColor: "#F5F5F5",
          },

          "&.selected": {
            backgroundColor: "#F5F5F5",
          },

          "& span": {
            display: "inline-block",
          },

          "& .country": {},

          "& .code": {
            color: colors.grey[600],
            marginLeft: 10,
          },
        },
      },
    },

    isoWrapper: {
      cursor: "pointer",

      "& .arrow": {
        marginLeft: 4,
        marginBottom: 2,
      },

      "& .dialCode": {
        width: "100%",
        fontSize: 13,
        fontWeight: theme.typography.fontWeightRegular,
        marginLeft: 6,
        marginTop: 2,
      },
    },

    inputWrapper: {
      width: "100%",
      height: "100%",
      paddingLeft: 10,

      "& input": {
        border: "none",
        outline: 0,
        height: "100%",
        width: "100%",

        fontSize: 14,
        fontWeight: theme.typography.fontWeightLight,

        "&:disabled": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "input-pn-style", flip: null }
);
